import "./components/nav-init.js";
import "./components/swiper-init.js";

import { initAnimation } from "./components/animation-init.js";
import { InterSectionObserver } from "./components/IntersectionObserver";
initAnimation();
InterSectionObserver();
